/**
 * @file   src\components\AppSettings.tsx
 * @brief  App Settings component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { React, useState, Button, useParams, useEffect, Modal } from '../utils/thirdpartyComponents';
import Backicon from '../assets/images/arrow-left.svg';
import AppDefaulttheme from './AppDefaulttheme';
import AppCustomizetheme from './AppCustomizetheme';
import { AppsettingshApi } from '../utils/apiUrls';
import { MessageToaster } from '../utils/toastUtil';
import axios from '../config/axiosConfig';
import SmallLoader from '../components/SmallLoader';
import { userType } from '../utils/enums';

const AppSettings = ({ onComplete, cuserType }: { onComplete: () => void; cuserType: string }) => {
    const [showCustomTheme, setshowCustomTheme] = useState(false);

    // Instantiate MessageToaster
    const toaster = new MessageToaster();
    const param = useParams();
    const [loading, setLoading] = useState(false);
    const carWashId = param.id ? parseInt(param.id) : 0

    // Add formData state to AppSettings
    const [formData, setFormData] = useState({
        appTheme: {
            primary: '',
            secondary: '',
            btn_primary: '',
            btn_secondary: '',
            text_primary: ''
        },
        logoUrl: '',
        IsCustom: 0,
        "carWashId": carWashId
    });

    const saveAppSettings = async () => {
        try {
            setLoading(true); // Show loader
            const responseaddAppSettings = (cuserType === userType['CARWASH-OWNER']) ?
                await axios.post(AppsettingshApi.CARWASH_OWNER_APP_SETTINGS_ADD, formData) :
                await axios.post(AppsettingshApi.APP_SETTINGS_ADD, formData);
            if (responseaddAppSettings?.data?.error === 0) {
                toaster.toastSuccess("Custom Branding added successfully.");
                setResetbuttonstatus(false);
                onComplete();
            }
            else {
                toaster.toastError(responseaddAppSettings?.data?.message);
            }

        } catch (error) {
            console.log(error);
            toaster.toastError('Failed to add Custom Branding.');
        } finally {
            setLoading(false); // Hide loader
        }
    }

    const showCustomThemeScreen = async () => {
        setshowCustomTheme(true);
    }
    const hideCustomThemeScreen = async () => {
        setshowCustomTheme(false);
    }

    // To get app settings
    const getAppSettings = async () => {
        try {
            setLoading(true); // Show loader
            const { data } = (cuserType === userType['CARWASH-OWNER']) ?
                await axios.get(AppsettingshApi.CARWASH_OWNER_GET_APP_SETTINGS) :
                await axios.get(AppsettingshApi.GET_APP_SETTINGS + carWashId);
            if (data.error === 0) {
                if (data.data.IsCustom === 1) {
                    showCustomThemeScreen();
                }
                else {
                    hideCustomThemeScreen();
                }
            }
        } catch (error: any) {
            toaster.toastError(error.response?.data?.message || error.message);
        } finally {
            setLoading(false); // Hide loader
        }
    }

    // Fetch app settings information on component mount
    useEffect(() => {
        getAppSettings();
    }, []);

    const [resetstatus, setResetstatus] = useState<boolean>(false);
    const [resetbuttonstatus, setResetbuttonstatus] = useState<boolean>(false);
    const resetCustomTheme = async () => {
        setResetstatus(true);
        setShowResetpoup(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    const [showResetpoup, setShowResetpoup] = useState<boolean>(false);
    //Hide ppopup
    const hideResetModal = () => {
        setShowResetpoup(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    const showResetModal = () => {
        setShowResetpoup(true);
    }

    return (
        <div className='step-content-outer'>
            <div className='common-wrap location-info-wrapper app-settings-wrapper'>
                {showCustomTheme && (
                    <Button variant="light" className="light-btn back-btn" onClick={hideCustomThemeScreen}>
                        <img src={Backicon} alt="Car wash app" />
                    </Button>
                )}
                <div className="title-block mx-auto text-center">
                    <h3 className='f-bold'>Custom Branding</h3>
                    <p className='f-medium'>Upload your logo and select a theme to match your company’s branding to enhance brand recall.</p>
                </div>
                {!showCustomTheme && <AppDefaulttheme showCustomThemeScreen={showCustomThemeScreen} formData={formData} setFormData={setFormData} cuserType={cuserType} />}
                {showCustomTheme && <AppCustomizetheme formData={formData} setFormData={setFormData} cuserType={cuserType} resetstatus={resetstatus} setResetstatus={setResetstatus} resetbuttonstatus={resetbuttonstatus} setResetbuttonstatus={setResetbuttonstatus} />}
            </div>
            <div className='btn-action-sec d-flex align-items-center justify-content-between'>
                <Button title="Reset" disabled={!resetbuttonstatus} variant="secondary" className="secondary-btn ms-auto" onClick={showResetModal}>Reset</Button>
                <Button title="Save" variant="primary" className="primary-btn" onClick={saveAppSettings}>Save</Button>
            </div>
            {loading && <SmallLoader />}
            <Modal
                show={showResetpoup}
                onHide={hideResetModal}
                centered
                className='add-modal'
            >
                <Modal.Body className='text-center'>
                    <h5 className='f-bold text-center'>Are you sure, you want to reset the theme?</h5>
                    <div className="btn-sec d-grid">
                        <Button title="Not Now" variant="light" className="secondary-btn" onClick={hideResetModal}>Not Now</Button>
                        <Button title='Yes' variant="primary" className='primary-btn btn-main m-0' onClick={resetCustomTheme}>Yes</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};
export default AppSettings;
